export const ADIMN_MANAGE_USER_START = "ADIMN_MANAGE_USER_START";
export const ADIMN_MANAGE_USER_SUCCESS = "ADIMN_MANAGE_USER_SUCCESS";
export const ADIMN_MANAGE_USER_ERROR = "ADIMN_MANAGE_USER_ERROR";